// extracted by mini-css-extract-plugin
module.exports = {"tilesColumn":"statDetailsTiles_tilesColumn__2Z8zG"};